import React from 'react';
import { ReactPhotoSphereViewer } from 'react-photo-sphere-viewer';
import { PanoramicImage } from '../../../hooks/useGetProperty';
import { useTranslation } from 'react-i18next';

import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'; 
import { GalleryPlugin } from '@photo-sphere-viewer/gallery-plugin';
import '@photo-sphere-viewer/gallery-plugin/index.css'; 

interface PanoramicViewerProps {
    images: PanoramicImage[];
}

const PhotoSphereViewer: React.FC<PanoramicViewerProps> = ({ images }) => {
    const { t } = useTranslation();

    if (!images || images.length === 0) {
        return null;
    }

    const galleryItems = images.map(img => ({
        id: img.id.toString(),
        panorama: img.urlBig,
        thumbnail: img.urlSmall,
        tooltip: {
            content: img.caption || '',
            position: 'top',
        },
    }));

    const plugins: any[] = [
        [GalleryPlugin, {
            thumbnailSize: { width: 100, height: 75 },
            items: galleryItems,
        }]
    ];

    return (
        <div className="panoramic-viewer-section rounded mb-5">
            <h4>
                {t('panoramic.title', 'Foto Panoramiche')}
            </h4>
            <div className="panoramic-content-box p-3">
                <div className="photo-sphere-container">
                    <ReactPhotoSphereViewer
                        src={images[0].urlBig}
                        height={'500px'}
                        width={'100%'}
                        littlePlanet={false}
                        plugins={plugins}
                        navbar={[
                            'autorotate',
                            'zoom',
                            'gallery',
                            'fullscreen',
                            'caption'
                        ]}
                    />
                </div>
            </div>
        </div>
    );
};

export default PhotoSphereViewer;